/**
 * Link Component
 * Accessible link component
 */

import React, { forwardRef } from 'react';
import { Box } from './Box';

/**
 * Link Component
 * Accessible hyperlink with style props
 * 
 * @example
 * <Link href="/about" color="brand.500">About Us</Link>
 * <Link href="https://example.com" isExternal>External Link</Link>
 */
export const Link = forwardRef(({
  isExternal,
  href,
  ...props
}, ref) => {
  const externalProps = isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer',
  } : {};

  return (
    <Box
      ref={ref}
      as="a"
      href={href}
      textDecoration="none"
      cursor="pointer"
      transition="color 0.15s"
      outline="none"
      _hover={{
        textDecoration: 'underline',
      }}
      _focus={{
        boxShadow: 'outline',
      }}
      {...externalProps}
      {...props}
    />
  );
});

Link.displayName = 'Link';

export default Link;
